import React from 'react';
import '../governance.css'
const GovernanceCard = ({ sliderCard, sliderInfo,imgHeight ,index,cardHeight }) => {
    const randomName = `govern-${index}`;
    const CardHeight = `
    .card-img-top{
        height: 300px ;
        
     }
    .${randomName}{
        height: ${cardHeight}px ;
     }
     @media(max-width: 575px){
     
        .${randomName}{
            height: inherit !important;
            padding-bottom:10px;
         }
    }
     @media(min-width: 1400px){
     
        .card-img-top{
            height: 270px ;
            width:270px;
          
         }
    }
    
   `;
    const finalClassName = `govern-card-container  ${randomName} `;
   
    return (
        <>
        <style>{CardHeight}</style>
        <div className={sliderCard ? "govern-card-col  " : "col-md-6  col-lg-4"}>
       
             <div className={finalClassName}>
                <img

                    src={sliderInfo?.img?.url}
                    className="card-img-top"
                    style={{height:`300px`}}
                    alt="Governing board img">

                </img>
                <div className="text-center py-2 px-1">
                    <h6 className="fw-bold py-2">{sliderInfo?.name}</h6>
                    <p className="secondary-text  mb-0">{sliderInfo?.designation}</p>
                    <small className="body-text ">{sliderInfo?.about_me}</small>
                </div>
            </div>
        </div>
        </>
    );

};

export default GovernanceCard;